(function () {
  var manage_product_customizer = function ($) {
    var pageURL = window.location.href;
    var lastURLSegment = pageURL.substr(pageURL.lastIndexOf("/") + 1);
    var product_id = "";
    var cart_item = "";
    var product_image_last_src = "";
    var smart_api_path = "https://customsizepricecalculator.com/ApiController";
    var smart_main_url = "https://customsizepricecalculator.com";
    var minimum_purchase_price = 0;
    var note_desc = "";
    var localhost_string = "localhost";
    var money_format = "";
    var currency = ["$"];
    var cureency_symolbs_last_stores = ["revalwallpaper.myshopify.com"];
    const shop_domain = Shopify.shop;
    const cur_path = window.location.pathname;
    const base_url_shopify = window.location.origin;
    var product_page = cur_path.indexOf("/products/");
    var product_id = 0;

    var prope_size_text = "Size";
    var prope_roll_text = "Roll";
    var prope_price_text = "Price";
    var prope_w_text = "W ";
    var prope_h_text = "H ";
    try {
      product_id = meta.product.id;
    } catch (err) {}
    var product_title = "";
    var product_price_meter = "";
    var cust_data = "";
    var smart_price_html = "";
    var custBtn_text = "CUSTOMISE & BUY";
    var exclude_product = "";
    var main_prod_details;
    var excludeProductArr = "";
    var btn_back_ground_color = "";
    var btn_text_color = "";

    var cart_Btn_text = "Add To Cart";
    var cart_btn_back_ground_color = "";
    var cart_btn_text_color = "";
    var button_style = "";
    var cart_button_style = "";
    var st_preset_details;
    if (product_page !== -1) {
      product_page = true;
    } else {
      product_page = false;
    }
    //if(mural_page !== -1){mural_page = true;}else {mural_page = false;}
    var shop_data = { shop_domain: shop_domain, product_id: product_id };

    var product_image = "";

    var product_image_id;
    var addtocart_class_names =
      " [name='add'] ,.pr_trust_seal,  .shopify-cleanslate,.btn--add-to-cart,.eo-sh-addToCart,.shopify-payment-button__button,.ProductForm__AddToCart";
    var show_inline = "on";
    var k_hight = "100";
    var k_width = "200";
    var shopify_m2_price = 15;
    var shopify_sft_price = 1.39;
    var variant_dtls = null;
    var default_in_cm_width = 0;
    var default_in_cm_height = 0;
    var default_in_inch_width = 0;
    var default_in_inch_height = 0;
    var calc_type = "sft";
    var prices_from_shopify = "";
    var custom_price = 0;
    var is_inline = "";
    var last_bag_price = 0;
    var product_roll = "";
    var price_unit = "";
    var preset_enable = "";
    var is_customize_image = "";
    var price_zeros_issue = "";
    var currency_symbol = "";
    var show_special_request = "";
    var special_request_style = 'style="display:none"';
    var variants_id_class = "";
    var calculator_title = "";
    var customize_btn_store = [
      "dynamicrooms.myshopify.com",
      "dipteststore.myshopify.com",
    ];
    var pop_up_btn_width = "";
    var max_width = 0;
    var max_height = 0;
    var max_size_enable = "";
    var min_size_enable = "";
    var repeat_image = "";
    var image_bottom_text = "";
    var is_aspect_ratio_option = "on";
    var aspect_ratio_text = "Fit the motif";
    var aspect_ratio_chekbox_display = "";
    var special_request_title = "Special Request";
    var width_title = "Width";
    var height_title = "Height";
    var total_title = "Total";
    var show_maxsize = "display:none";
    var image_crop_required = "";
    var cust_pro_attr = [];
    var is_circle_product = false;
    var is_both_rect_circle = false;
    var circle_rectangle_stores = [
      "linenshed-fr.myshopify.com",
      "dilli999.myshopify.com",
    ];
    var diameter_title = "Diameter";
    var upload_image_to_cart_urls = ["canvascampaign.myshopify.com"];
    let no_round_of_domains = ["dilli999.myshopify.com"];
    function set_store_custom_attributes() {
      if (shop_domain == "linenshed-fr.myshopify.com") {
        cust_pro_attr = [
          "Choisissez la première couleur ici:",
          "Choisissez une Seconde couleur ici:",
          "Choisissez la couleur du bourdon",
          "Choisissez une couleur",
          "Couleur du Feston",
        ];
      } else if (shop_domain == "decochicnew.myshopify.com") {
        cust_pro_attr = ["Colore Fantasia"];
      }
    }

    var getCurrentScript = function () {
      try {
        if (document.currentScript && document.currentScript.src !== "")
          return document.currentScript.src;
        var scripts = document.getElementsByTagName("script"),
          str = scripts[scripts.length - 1].src;
        if (str !== "") return src;
        return new Error().stack.match(/(https?:[^:]*)/)[0];
      } catch (err) {
        return "customsizepricecalculator.com";
      }
    };

    var getCurrentScriptPath = function () {
      var script = getCurrentScript(),
        path = script.substring(0, script.lastIndexOf("/"));
      return path;
    };

    var setEnvURL = function () {
      var eUrl = getCurrentScriptPath();
      if (eUrl.indexOf(localhost_string) > 0) {
        // smart_api_path= 'https://localhost/smart-price-calculator/ApiController';
        // smart_main_url='https://localhost/smart-price-calculator';
      }
      if (shop_domain == "dilli999.myshopify.com") {
        // smart_api_path= 'https://localhost/smart-price-calculator/ApiController';
        //smart_main_url='https://localhost/smart-price-calculator';
      }
    };

    function confirm_order() {
      if (lastURLSegment == "thank_you") {
        for (var i = 0; i < Shopify.checkout.line_items.length; i++) {
          product_id += Shopify.checkout.line_items[i].product_id + ",";
        }
        var xhttp = new XMLHttpRequest();
        xhttp.open("POST", smart_api_path + "/unpublish_products/", true);
        xhttp.setRequestHeader("Content-Type", "application/json");
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            // Response
            var response = this.responseText;
          }
        };
        //var data = {name:'yogesh',salary: 35000,email: 'yogesh@makitweb.com'};
        var data = { product_ids: product_id };

        xhttp.send(JSON.stringify(data));
      }
    }

    function set_money_format() {
      try {
        money_format = theme.moneyFormat;
        currency = money_format.split("{{");
      } catch (ex) {}
    }

    function add_cs_urls() {
      //$(document).find('.price__regular dd').append('<b>/m2</b>');
      $(document).ready(function () {
        $("head").append(
          '<link rel="stylesheet" rel="nofollow" href="' +
            smart_main_url +
            '/assets/css/smart-price.css?v=2" type="text/css" />'
        );
        $("head").append(
          '<link href="https://fonts.googleapis.com/css2?family=Playfair+Display&display=swap" rel="stylesheet">'
        );
        $("head").append(
          '<link href="https://fonts.googleapis.com/css2?family=Oswald:wght@300&display=swap" rel="stylesheet">'
        );
      });
    }
    function getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    function set_property_translation() {
      prope_size_text = "Size";
      prope_roll_text = "Roll";
      prope_price_text = "Price";
      prope_w_text = "W ";
      prope_h_text = "H ";
      if (shop_domain == "esprit-panoramique.myshopify.com") {
        prope_w_text = "L ";
      }
      if (shop_domain == "plisseworld.myshopify.com") {
        prope_w_text = "B ";
        prope_price_text = "Pris";
        prope_size_text = "Størrelse";
      }
      if (shop_domain == "kkkk1231214.myshopify.com") {
        prope_w_text = "Largura ";
        prope_h_text = "Altura ";
        prope_price_text = "Preço";
        prope_size_text = "Tamanho";
      }
    }
    function get_inch_cm_switch_html(is_main_page = false) {
      return (
        '<div class="grid_row">' +
        '<div style="display:none" class="switch_properties">' +
        '<a href="#" id="inch" class="ainch">inch</a> <span>|</span>' +
        '<a href="#" id="cm" class="acm">cm</a>' +
        "</div></div>"
      );
    }

    function get_inch_section_html(is_main_page = false) {
      var spe_class = "";
      var main_div_bg_color = "#f1f1f1;";
      if (cust_data.calculator_title !== "") {
        main_div_bg_color = cust_data.calculator_bgcolor + ";";
      }
      var main_div_inline_style =
        "padding:20px !important;background-color:" + main_div_bg_color;
      if (shop_domain == "decochicnew.myshopify.com") {
        main_div_inline_style =
          "padding:20px 0px !important;background-color:" + main_div_bg_color;
      }

      if (is_main_page == false) {
        spe_class = "msp_span_1_of_3";
      } else {
        main_div_inline_style += "clear:both !important;";
      }

      if (shop_domain == "eurowalls.myshopify.com") {
        main_div_inline_style += "margin-bottom:40px !important";
      }

      var start_div_html =
        '<div class="grid_col ' +
        spe_class +
        ' ajax_column border_full extra_margin" style="' +
        main_div_inline_style +
        '" >';
      if (is_main_page == true) {
        start_div_html =
          '<div id="customize-btn" class="customize-btn Button"> CALCULATE NUMBER OF ROLLS</div><div class="ms_smart_price_main_div hide" style="' +
          main_div_inline_style +
          '" >';
      }
      calculator_title = cust_data.calculator_title;
      if (calculator_title == "") {
        calculator_title = "Your Wall Dimensions";
      }
      if (cust_data.special_request_title !== "") {
        special_request_title = cust_data.special_request_title;
      }
      if (cust_data.width_title !== "") {
        width_title = cust_data.width_title;
      }
      if (cust_data.height_title !== "") {
        height_title = cust_data.height_title;
      }
      if (cust_data.diameter_title !== "") {
        diameter_title = cust_data.diameter_title;
      }

      if (cust_data.total_title !== "") {
        total_title = cust_data.total_title;
      }
      if (cust_data.show_maxsize == 1) {
        show_maxsize = "display:block";
      }
      var display_height = "";
      if (is_circle_product) {
        display_height = "display:none";
        width_title = diameter_title;
      }
      if (shop_domain == "window-kanopy.myshopify.com") {
        display_height = "display:none";
      }

      var rect_circle_radio_html = "";
      if (is_both_rect_circle == true) {
        var chekc_rec = "checked";
        var check_circle = "checked";
        if (is_circle_product == false) {
          check_circle = "";
        } else {
          chekc_rec = "";
        }
        rect_circle_radio_html = `<div>
    <label style="display:inline-block !important;padding-right:15px !important">
    <input type="radio" name="rec_cir" class="rec_cir_radio" value='rectangle' ${chekc_rec}>
    <span class="rec_cir_span">Rectangle</span>
    </label>
    <label style="display:inline-block !important">
    <input type="radio" name="rec_cir" class="rec_cir_radio" value='circle' ${check_circle} >
    <span class="rec_cir_span">Circle</span>
    </label>
   
    </div>`;
      }
      if (upload_image_to_cart_urls.includes(shop_domain)) {
        start_div_html +=
          'Image uplaod <input required id="myuplaodimg" type="file" name="properties[Photo]">';
      }

      return (
        start_div_html +
        '<div style=""><h3 class="content_title">' +
        calculator_title +
        "</h3>" +
        '<div class="content_divider"></div>' +
        get__preset_sizes_html() +
        rect_circle_radio_html +
        '<div class="cm_cal_area">' +
        '<div class="grid_row calfield_cm">' +
        '<div class="grid_col span_1_of_2">' +
        "<label><strong>" +
        width_title +
        "</strong> (cm)</label>" +
        '<input type="number" data-msrtype="cm" id="width_in_cm" name="properties[width[CM]]" value="' +
        cust_data.cm_width +
        '" class="conversion_txtboxes cm-width " style="width:100%">' +
        '<p style="font-size:12px;margin:0;color:#a7a7a7;' +
        show_maxsize +
        '">Max: ' +
        max_width +
        " cm</p>" +
        "</div>" +
        '<div class="grid_col span_1_of_2 height_section_cm" style="' +
        display_height +
        '">' +
        "<label><strong>" +
        height_title +
        "</strong> (cm)</label>" +
        '<input type="number"data-msrtype="cm"  id="height_in_cm" name="properties[height[CM]]" value="' +
        cust_data.cm_height +
        '" class="conversion_txtboxes cm-height" style="width:100%">' +
        '<p style="font-size:12px;margin:0;color:#a7a7a7;' +
        show_maxsize +
        '">Max: ' +
        max_height +
        " cm</p>" +
        "</div>" +
        "</div></div>" +
        '<div class="inch_cal_area">' +
        '<div class="grid_row calfield_inch">' +
        '<div class="grid_col span_1_of_2">' +
        " <label><strong>" +
        width_title +
        "</strong> (inch)</label>" +
        '<input type="number"  data-msrtype="inch" id="width_in_inch" name="width_in_inch" value="' +
        cust_data.inch_width +
        '"  class="conversion_txtboxes inch-width" style="width: 100%;" min="1" >' +
        '<p style="font-size:12px;margin:0;color:#a7a7a7;' +
        show_maxsize +
        '">Max: ' +
        max_width +
        " inch</p>" +
        "</div>" +
        '<div class="grid_col span_1_of_2 height_section_inch" style="' +
        display_height +
        '">' +
        "<label><strong>" +
        height_title +
        "</strong> (inch)</label>" +
        '<input type="number"   data-msrtype="inch" id="height_in_inch" value="' +
        cust_data.inch_height +
        '" class="conversion_txtboxes inch-height" style="width: 100%;" min="1" >' +
        '<p style="font-size:12px;margin:0;color:#a7a7a7;' +
        show_maxsize +
        '">Max: ' +
        max_height +
        " inch</p>" +
        "</div></div>" +
        "</div></div>"
      );
    }
    function get_price_notes_html() {
      var spl_notes_html = "";
      if (shop_domain == "eurowalls.myshopify.com") {
        spl_notes_html += `<div class="ms_sp_spl_notes_text" style="font-weight:bold !important;padding-top:10px !important">
                        *Please add 10cm to the width and height of your wall measurements.
                         This extra allowance is for trimmings during installation so the mural fits your wall perfectly.
                    </div>`;
      }

      $shop_extra_features_html = "";
      if (shop_domain == "kkkk1231214.myshopify.com") {
        $shop_extra_features_html = `<div  class="grid_row">
                              <label class="order_extra_label">Lado da cordinha:</label><br/>
                              <input type="radio" name="Ladodacordinha" checked value="Direita"> Direita
                              <input type="radio" name="Ladodacordinha" value="Esquerda"> Esquerda
                              <input type="radio" name="Ladodacordinha" value=" Centro para laterais">  Centro para laterais
                              </div>`;
      }
      let product_properties_price =
        currency_symbol + "" + two_decimal_format(product_price_meter);
      if (no_round_of_domains.includes(shop_domain)) {
        product_properties_price = currency_symbol + "" + product_price_meter;
      }
      if (shop_domain == "esprit-panoramique.myshopify.com") {
        product_properties_price =
          two_decimal_format(product_price_meter) + " " + currency_symbol;
      }
      if (cureency_symolbs_last_stores.includes(shop_domain)) {
        product_properties_price =
          two_decimal_format(product_price_meter) + " " + currency_symbol;
      }
      return (
        '<div class="content_divider_secondary"></div>' +
        '<div class="grid_row">' +
        '<div class="calculated_estimate" style="font-weight:bold">' +
        '<div class="product_proper">' +
        "You need " +
        '<span class="count-roll"></span> rolls</div>' +
        '<div style="font-size:20px !important;margin:5px 0 5px !important" ><span >' +
        total_title +
        ' : </span><span class="product_pricing">$0</span></div>' +
        '<div class="product_properties" name="priceper">' +
        product_properties_price +
        "/Sq. m2</div>" +
        '<h5 id="validation_line"><span style="color:red">Minimum order:  ' +
        minimum_purchase_price +
        "</span></h5>" +
        "</div>" +
        "</div>" +
        '<div class="content_divider_secondary"></div>' +
        $shop_extra_features_html +
        '<div class="grid_row" ' +
        special_request_style +
        '><label class="order_comment_label">' +
        special_request_title +
        ":</label>" +
        '<textarea class="order_comment ful_width"></textarea>' +
        "</div>" +
        spl_notes_html
      );
    }
    function attach_variant_change() {
      if (shop_domain == "eurowalls.myshopify.com") {
        eruowall_shop_color_change();
      } else {
        $("#option-scegli-il-materiale").on("change", function () {
          setTimeout(() => {
            (async () => {
              variant_dtls = await currentVariant();
              console.log(variant_dtls);
              set_varaint_details();
              if (iselemetVisible($(".inch_cal_area")[0])) {
                $(".inch-width").trigger("change");
              } else {
                $(".cm-width").trigger("change");
              }
            })();
          }, 100);
        });

        $("#option-colore").on("change", function () {
          setTimeout(() => {
            (async () => {
              variant_dtls = await currentVariant();
              console.log(variant_dtls);
              set_varaint_details();
              if (iselemetVisible($(".inch_cal_area")[0])) {
                $(".inch-width").trigger("change");
              } else {
                $(".cm-width").trigger("change");
              }
            })();
          }, 100);
        });
      }
    }
    function eruowall_shop_color_change() {
      $(".swatches-select")
        .find("li")
        .on("click", function () {
          setTimeout(() => {
            (async () => {
              variant_dtls = await currentVariant();
              // console.log(variant_dtls);
              set_varaint_details();
              if (iselemetVisible($(".inch_cal_area")[0])) {
                $(".inch-width").trigger("change");
              } else {
                $(".cm-width").trigger("change");
              }

              setTimeout(() => {
                $(".single_add_to_cart_button").each(function () {
                  if ($(this).hasClass("js_frm_cart")) {
                    $(this).hide();
                  }
                });
              }, 100);
            })();
          }, 100);
        });
    }
    function get_smart_price_data() {
      $.getJSON(
        smart_api_path + "/get_customizer_api/",
        shop_data,
        function (data_resp) {
          if (shop_domain == "hushindia.myshopify.com") {
            setTimeout(function () {
              main_get_data(data_resp);
            }, 100);
          } else {
            main_get_data(data_resp);
          }
        }
      );
    }

    function main_get_data(data_resp) {
      set_property_translation();
      set_store_custom_attributes();

      if (circle_rectangle_stores.includes(shop_domain)) {
        is_both_rect_circle = true;
      }

      exclded_product_or_not(data_resp);
      if (
        data_resp.customizer.app_enable == "on" &&
        exclude_product == "false"
      ) {
        max_size_enable = data_resp.product_details.max_size_enable;
        min_size_enable = data_resp.product_details.min_size_enable;

        if (max_size_enable == "on") {
          max_width = data_resp.product_details.max_width;
          max_height = data_resp.product_details.max_height;
        } else {
          max_width = "";
          max_height = "";
        }
        if (min_size_enable == "on") {
          min_width = data_resp.product_details.min_width;
          min_height = data_resp.product_details.min_height;
        } else {
          min_width = "";
          min_height = "";
        }
        set_api_data(data_resp);
        (async () => {
          variant_dtls = await currentVariant();
          if (prices_from_shopify == "") {
            custom_price = data_resp.product_details.price;
          }
          setTimeout(() => {
            set_varaint_details();
            prepare_final_html(data_resp);
            circl_rect_change();
            convert_new_functions();

            set_default_values_and_trigger();
            attach_popup_button_click_event();
            $("#validation_line").hide();
            $("#chartContainer").width(default_in_cm_width);
            $("#chartContainer").height(default_in_cm_height);
            $("#chartContainer").width(345).height(230);
            attach_inch_cm_change_events();

            attach_add_to_bag_event();
            attach_variants_chnage_event();
            attach_presset_button_events();
            add_css();
            attach_variant_change();
          }, 100);
        })();
      }
    }

    function two_decimal_format(value, exp = 2) {
      if (typeof exp === "undefined" || +exp === 0) return Math.round(value);

      value = +value;
      exp = +exp;

      if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0))
        return NaN;

      // Shift
      value = value.toString().split("e");
      value = Math.round(
        +(value[0] + "e" + (value[1] ? +value[1] + exp : exp))
      );

      // Shift back
      value = value.toString().split("e");
      var final_value_round = +(
        value[0] +
        "e" +
        (value[1] ? +value[1] - exp : -exp)
      );
      final_value_round = final_value_round.toFixed(2);
      var spl_val = final_value_round.split(".");
      if (spl_val[1] == "00") {
        return spl_val[0];
      }
      return final_value_round;
    }

    function set_leg_price_mes(type) {
      let hide_price_per_unit_stores = [
        "hushindia.myshopify.com",
        "window-kanopy.myshopify.com",
      ];
      if (hide_price_per_unit_stores.includes(shop_domain)) {
        $(".product_properties").hide();
      }
      var me_type = "";
      if (type == "cm") {
        me_type = price_unit;
        if (price_unit == "m2") {
          me_type = "m";
        }
        if (
          cust_data.display_price_unit == "" ||
          cust_data.display_price_unit == "squnit"
        ) {
          let product_properties_price =
            "(" +
            currency_symbol +
            "" +
            two_decimal_format(shopify_m2_price) +
            "/" +
            "Sq. " +
            me_type +
            ".)";
          if (no_round_of_domains.includes(shop_domain)) {
            product_properties_price =
              "(" +
              currency_symbol +
              "" +
              shopify_m2_price +
              "/" +
              "Sq. " +
              me_type +
              ".)";
          }

          $(".product_properties").html(product_properties_price);
        }
        if (cust_data.display_price_unit == "unit2") {
          if (shop_domain == "esprit-panoramique.myshopify.com") {
            $(".product_properties").html(
              "(" +
                two_decimal_format(shopify_m2_price) +
                " " +
                currency_symbol +
                "/" +
                me_type +
                "<sup>2</sup>)"
            );
          } else {
            $(".product_properties").html(
              "(" +
                currency_symbol +
                "" +
                two_decimal_format(shopify_m2_price) +
                "/" +
                me_type +
                "<sup>2</sup>)"
            );
            if (cureency_symolbs_last_stores.includes(shop_domain)) {
              $(".product_properties").html(
                "(" +
                  two_decimal_format(shopify_m2_price) +
                  currency_symbol +
                  "" +
                  "/" +
                  me_type +
                  "<sup>2</sup>)"
              );
            }
          }
        }
      } else {
        me_type = price_unit;
        if (price_unit == "sft") {
          me_type = "ft";
        }
        if (
          cust_data.display_price_unit == "" ||
          cust_data.display_price_unit == "squnit"
        ) {
          $(".product_properties").html(
            "(" +
              currency_symbol +
              "" +
              two_decimal_format(shopify_sft_price) +
              "/" +
              "Sq. " +
              me_type +
              ".)"
          );
        }
        if (cust_data.display_price_unit == "unit2") {
          $(".product_properties").html(
            "(" +
              currency_symbol +
              "" +
              two_decimal_format(shopify_sft_price) +
              "/" +
              me_type +
              "<sup>2</sup>)"
          );
        }
      }
    }
    function convert_ratio_height(type) {
      (i = max_height > 0 ? max_height : $("." + type + "-height").val()),
        (n = max_width > 0 ? max_width : $("." + type + "-width").val()),
        (o = Number((($("." + type + "-width").val() / n) * i).toFixed(0)));
      $("." + type + "-height").val(o - Math.floor(o) == 0 ? o : Math.floor(o));
    }
    function check_min_max(type) {
      var t_height = Number($("." + type + "-height").val());
      var t_width = Number($("." + type + "-width").val());
      if (min_size_enable == "on") {
        if (t_width < min_width) {
          $("." + type + "-width").val(min_width);
        }
        if (t_height < min_height) {
          $("." + type + "-height").val(min_height);
        }
      }
      if (max_size_enable == "on") {
        if (t_width > max_width) {
          $("." + type + "-width").val(max_width);
        }

        if (t_height > max_height) {
          $("." + type + "-height").val(max_height);
        }
      }

      if (is_aspect_ratio_option == "on") {
        if ($("#chkAspectration").is(":checked")) {
          convert_ratio_height(type);
        }
      }
    }
    $("body").on("click", "#chkAspectration", function () {
      if ($("#chkAspectration").is(":checked") == false) {
        return;
      }
      if (calc_type == "m2" || calc_type == "cm") {
        $(".cm-width").trigger("change");
        return;
      } else if (calc_type == "sft" || calc_type == "inch") {
        $(".inch-width").trigger("change");
        return;
      }

      return;
    });
    function circl_rect_change() {
      $(".rec_cir_radio").on("change", function () {
        var type = "inch";
        if (calc_type == "m2" || calc_type == "cm") {
          type = "cm";
        }
        $("#width_in_" + type).val("0");
        $("#height_in_" + type).val("0");
        $(".product_pricing").html(currency_symbol + "" + "0");

        if ($(this).val() == "rectangle") {
          is_circle_product = false;
          $(".height_section_" + type).show();
          $("#width_in_" + type)
            .parent()
            .find("label")
            .html(`<strong>${cust_data.width_title}</strong> (${type})`);
          $("#leg_value").html("W 0 " + type + " * H 0" + " " + type);
        } else {
          var di_title = cust_data.diameter_title;
          is_circle_product = true;
          $("#leg_value").html(di_title + " 0 " + type);

          $(".height_section_" + type).hide();
          $("#width_in_" + type)
            .parent()
            .find("label")
            .html(`<strong>${di_title}</strong> (${type})`);
        }
      });
    }
    function get_next_round_value(inputValue, nextRound) {
      if (nextRound <= 0) {
        return inputValue;
      }
      let final_val = 0;
      try {
        final_val = parseInt(inputValue);
        nextRound = parseInt(nextRound);
        let modValue = final_val % nextRound;

        if (modValue > 0) {
          let quotientVal = final_val / nextRound;
          return Math.ceil(quotientVal) * nextRound;
        }
        return inputValue;
      } catch (ex) {
        return inputValue;
      }
    }
    function round_to_next_integer() {
      let c_width = $(".cm-width").val();
      let c_height = $(".cm-height").val();
      $(".cm-width").val(get_next_round_value(c_width, min_width));
      $(".cm-height").val(get_next_round_value(c_height, min_height));
    }
    function convert_new_functions() {
      $(".conversion_txtboxes").on("change", function () {
        if (shop_domain === "dilli999.myshopify.com") {
          round_to_next_integer();
        }
        var type = $(this).attr("data-msrtype");
        check_min_max(type);
        update_inline_popup_values(type, this);
        var final_cost_clac = 0;
        if (type == "cm") {
          convert_cm_to_inches();
          final_cost_clac = calculate_cm_price();
          width_value = $(".cm-width").val();
          height_value = $(".cm-height").val();
          set_image_width_heights("cm");
        } else if (type == "inch") {
          convert_inches_to_cm();
          final_cost_clac = calculate_inch_price();
          width_value = $(".inch-width").val();
          height_value = $(".inch-height").val();
          set_image_width_heights("inch");
        }
        set_price_value_to_divs(
          final_cost_clac,
          type,
          width_value,
          height_value
        );
      });
    }
    function set_price_value_to_divs(
      final_cost_clac,
      type,
      width_value,
      height_value,
      width_cm_cal
    ) {
      if (final_cost_clac < minimum_purchase_price) {
        final_cost_clac = minimum_purchase_price;
      }
      set_leg_price_mes(type);
      var width_cm_cal = parseFloat($(".inch-width").val());
      product_roll = Math.ceil(width_cm_cal / 70.87);
      last_bag_price = two_decimal_format(final_cost_clac, 2);
      $(".count-roll").html(product_roll);
      $(".product_pricing").html(currency_symbol + "" + last_bag_price);

      if (cureency_symolbs_last_stores.includes(shop_domain)) {
        $(".product_pricing").html(last_bag_price + " " + currency_symbol);
      }
      if (is_circle_product) {
        $("#leg_value").html(
          diameter_title + " " + two_decimal_format(width_value) + " " + type
        );
      } else {
        $("#leg_value").html(
          prope_w_text +
            two_decimal_format(width_value) +
            " " +
            type +
            " * " +
            prope_h_text +
            two_decimal_format(height_value) +
            " " +
            type
        );
      }
    }
    function calculate_cm_price() {
      var width_cm_cal = parseFloat($(".cm-width").val());
      var height_cm_cal = parseFloat($(".cm-height").val());
      var sq_m2_cal = width_cm_cal * height_cm_cal * 0.0001;

      if (price_unit == "m2" || price_unit == "sft") {
        if (is_circle_product == true) {
          sq_m2_cal =
            ((((3.14 * width_cm_cal) / 2) * width_cm_cal) / 2) * 0.0001;
        } else {
          sq_m2_cal = width_cm_cal * height_cm_cal * 0.0001;
        }
      } else if (price_unit == "cm" || price_unit == "inch") {
        if (is_circle_product == true) {
          sq_m2_cal = (((3.14 * width_cm_cal) / 2) * width_cm_cal) / 2;
        } else {
          sq_m2_cal = width_cm_cal * height_cm_cal;
        }
      }
      //var m2final_price=sq_m2_cal * shopify_m2_price;
      var m2final_price = Math.ceil(width_cm_cal / 180) * shopify_m2_price;
      return m2final_price;
    }
    function calculate_inch_price() {
      var width_inch_cal = parseFloat($(".inch-width").val());
      var height_inch_cal = parseFloat($(".inch-height").val());
      var sq_inch_cal = 0;
      if (price_unit == "m2" || price_unit == "sft") {
        if (is_circle_product == true) {
          sq_inch_cal =
            ((((3.14 * width_inch_cal) / 2) * width_inch_cal) / 2) * 0.00694444;
        } else {
          sq_inch_cal = width_inch_cal * height_inch_cal * 0.00694444;
        }
      } else if (price_unit == "cm" || price_unit == "inch") {
        if (is_circle_product == true) {
          sq_inch_cal = (((3.14 * width_inch_cal) / 2) * width_inch_cal) / 2;
        } else {
          sq_inch_cal = width_inch_cal * height_inch_cal;
        }
      }
      var inch_final_price = Math.ceil(sq_inch_cal / 70.87) * shopify_sft_price;
      //  var inch_final_price = sq_inch_cal * shopify_sft_price;
      return inch_final_price;
    }
    function update_inline_popup_values(type, obj) {
      if ($(obj).hasClass(type + "-width")) {
        $("." + type + "-width").val(two_decimal_format($(obj).val()));
      }
      if ($(obj).hasClass(type + "-height")) {
        $("." + type + "-height").val(two_decimal_format($(obj).val()));
      }
    }
    function convert_inches_to_cm() {
      var local_width_inch = parseFloat($(".inch-width").val());
      var local_height_inch = parseFloat($(".inch-height").val());
      $(".cm-width").val(two_decimal_format(local_width_inch * 2.54));
      $(".cm-height").val(two_decimal_format(local_height_inch * 2.54));
    }
    function convert_cm_to_inches() {
      var local_width_cm = parseFloat($(".cm-width").val());
      var local_height_cm = parseFloat($(".cm-height").val());
      $(".inch-width").val(two_decimal_format(local_width_cm / 2.54));
      $(".inch-height").val(two_decimal_format(local_height_cm / 2.54));
    }
    function convertion_func(type, obj) {
      var color = $(".a" + type).css("text-decoration-line");

      var show_area = "";
      var hide_area = "";
      var underline_id = "";
      var back_grd_id = "";
      if (type == "cm") {
        show_area = "cm_cal_area";
        hide_area = "inch_cal_area";
        underline_id = "inch";
        width_value = $(".cm-width").val();
        height_value = $(".cm-height").val();
        set_leg_price_mes(type);
      } else {
        show_area = "inch_cal_area";
        hide_area = "cm_cal_area";
        underline_id = "cm";
        set_leg_price_mes(type);
      }
      $("." + show_area).show();
      $("." + hide_area).hide();

      $("#" + underline_id).css("text-decoration-line", "underline");
      $(".a" + type).css("text-decoration-line", "none");
      $(".a" + type).css("background", "#4F5E44");
      $(".a" + type).css("color", "white");
      $(".a" + type).css("padding", "4px");
      $(".a" + type).css("border-radius", "2px");

      $(".a" + underline_id).css("background", "white");
      $(".a" + underline_id).css("color", "#4F5E44");
      //leg val change on cal
      if (type == "cm") {
        final_cost_clac = calculate_cm_price();
        width_value = $(".cm-width").val();
        height_value = $(".cm-height").val();
      } else {
        final_cost_clac = calculate_inch_price();
        width_value = $(".inch-width").val();
        height_value = $(".inch-height").val();
      }

      set_price_value_to_divs(final_cost_clac, type, width_value, height_value);

      // productprice_details_change(type,final_cost);

      return final_cost_clac;
    }

    /*cart_item = $('#width_in_cm').val()+' cm x '+$('#height_in_cm').val()+' cm';*/
    function canva_scaleToFill(img, cwidth, cheight) {
      var canvas = document.getElementById("file-preview");
      canvas.width = cwidth;
      canvas.height = cheight;
      var ctx = canvas.getContext("2d");
      // get the scale
      var ratio = cwidth / cheight;
      var scale = Math.max(
        canvas.width / img.width,
        canvas.height / img.height
      );
      // get the top left position of the image
      var x = canvas.width / 2 - (img.width / 2) * scale;
      var y = canvas.height / 2 - (img.height / 2) * scale;
      // ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
      ctx.drawImage(img, 0, 0, img.width * scale, img.height * scale);
    }

    function maximizeSize(width, height, maxWidth, maxHeight) {
      if (width / height > maxWidth / maxHeight) var ratio = maxWidth / width;
      else ratio = maxHeight / height;
      return {
        width: (width *= ratio),
        height: (height *= ratio),
      };
    }

    var cropWidth = 100;
    var cropHeight = 100;
    var crop_api;
    var crop_size_coordinates;
    var crop_set_main_img = 0;
    function crop_selection() {
      var x1 = cropWidth;
      var y1 = cropHeight;

      var x = 0;
      var y = 0;

      crop_api.setSelect([x, y, x1, cropHeight]);
      get_crop_image_b64();
    }
    function get_crop_box_height() {
      var box_height = 550;
      if ($(window).width() > 1280) {
        box_height = 550;
      } else if ($(window).width() >= 1280) {
        box_height = 480;
      } else if ($(window).width() >= 1024) {
        box_height = 510;
      } else if ($(window).width() >= 768) {
        box_height = 410;
      } else if ($(window).width() >= 540) {
        box_height = 310;
      } else if ($(window).width() >= 414) {
        box_height = 238;
      } else if ($(window).width() >= 411) {
        box_height = 235;
      } else if ($(window).width() >= 375) {
        box_height = 215;
      } else if ($(window).width() >= 360) {
        box_height = 205;
      } else if ($(window).width() >= 320) {
        box_height = 180;
      } else if ($(window).width() >= 280) {
        box_height = 160;
      }
      return box_height;
    }
    function set_crop_load(aspectRatio) {
      if ($(".jcrop-holder").length > 0) {
        crop_selection();
        return;
      }
      // set default options
      var opt = {};

      // if height and width must be exact, dont allow resizing
      opt.allowResize = false;
      opt.allowSelect = false;
      //opt.aspectRatio= 1;
      opt.boxWidth = cropWidth; //Maximum width you want for your bigger images 360-205 320-180
      opt.boxHeight = get_crop_box_height();
      (opt.onSelect = function (c) {
        crop_size_coordinates = { x: c.x, y: c.y, w: c.w, h: c.h };
        get_crop_image_b64();
        console.log(crop_size_coordinates);
      }),
        (opt.onChange = function (c) {
          crop_size_coordinates = { x: c.x, y: c.y, w: c.w, h: c.h };
          console.log(crop_size_coordinates);
          get_crop_image_b64();
        }); //end onSelect
      // initialize jcrop
      crop_api = $.Jcrop("#cropbox", opt);

      // set the selection area [left, top, width, height]
      crop_api.animateTo([0, 0, cropWidth, cropHeight]);

      // you can also set selection area without the fancy animation

      crop_api.setSelect([0, 0, cropWidth, cropHeight]);
      $("#cropbox").hide();
    }

    function move_image() {
      return;
      var $bg = $("#divchartContainer"),
        elbounds = {
          w: parseInt($bg.width()),
          h: parseInt($bg.height()),
        },
        bounds = { w: elbounds.w, h: elbounds.h },
        origin = { x: 0, y: 0 },
        start = { x: 0, y: 0 },
        movecontinue = false;

      function move(e) {
        var inbounds = { x: false, y: false },
          offset = {
            x: start.x - (origin.x - e.clientX),
            y: start.y - (origin.y - e.clientY),
          };

        inbounds.x = offset.x < 0 && offset.x * -1 < bounds.w;
        inbounds.y = offset.y < 0 && offset.y * -1 < bounds.h;

        if (movecontinue && inbounds.x && inbounds.y) {
          start.x = offset.x;
          start.y = offset.y;

          $(this).css("background-position", start.x + "px " + start.y + "px");
        }

        origin.x = e.clientX;
        origin.y = e.clientY;

        e.stopPropagation();
        return false;
      }

      function handle(e) {
        movecontinue = false;
        $bg.unbind("mousemove", move);

        if (e.type == "mousedown") {
          origin.x = e.clientX;
          origin.y = e.clientY;
          movecontinue = true;
          $bg.bind("mousemove", move);
        } else {
          $(document.body).focus();
        }

        e.stopPropagation();
        return false;
      }

      function reset() {
        start = { x: 0, y: 0 };
        $(this).css("backgroundPosition", "0 0");
      }

      $bg.bind("mousedown mouseup mouseleave", handle);
      $bg.bind("dblclick", reset);
      reset();
    }
    function prepare_image_sizes(k_width, k_hight, isPixels) {
      if (k_width == 0) {
        k_width = 400;
      }
      if (k_hight == 0) {
        k_hight = 400;
      }
      if (repeat_image == "") {
        if (image_crop_required == "on") {
          $("#divchartContainer").hide();
        } else {
          $("#cropbox").hide();
          $("#divchartContainer").show();
        }
      } else {
        $("#cropbox").hide();
        $("#divchartContainer").show();
      }
      $("#chartContainer").remove();

      var screen_max_width = 800;
      var screen_max_height = 400;
      if ($(window).width() < 400) {
        screen_max_width = $(window).width() - 40;
        screen_max_height = screen_max_width - 60;
      } else if ($(window).width() <= 1000) {
        screen_max_width = $(window).width() - 40;
        screen_max_height = 250;
      }

      var sizes = maximizeSize(
        k_width,
        k_hight,
        screen_max_width,
        screen_max_height
      );
      var img = new Image();
      img.src = product_image_last_src;

      img.onload = function () {
        var actual_width = sizes.width;
        var actual_height = sizes.height;
        var image_original_width = img.width;
        var image_original_height = img.height;
        var aspectRatio = 0;
        var img_max_height = 400;
        image_original_width = img.width;
        image_original_height = img.height;
        aspectRatio = image_original_width / image_original_height;
        if (repeat_image == "") {
          if (image_crop_required == "on") {
          } else {
            k_hight = sizes.height;
            k_width = sizes.width;
            k_width = Math.round(k_hight * aspectRatio);
          }
        } else {
          k_hight = sizes.height;
          k_width = sizes.width;
          k_width = Math.round(k_hight * aspectRatio);
        }

        $("#divchartContainer").show();
        $("#fig_pro").width(k_width);
        $("#fig_pro").height(k_hight);
        $("#temp").show();

        var w = $("#temp").find("#main-imag").width();
        var h = $("#temp").find("#main-imag").height();

        $("#chartContainer").remove();

        $("#divchartContainer").html(" ");
        if (w == 0 && h == 0) {
          w = k_width;
          h = k_hight;
        }

        if (repeat_image == "") {
          if (image_crop_required == "on") {
            $("#divchartContainer").hide();
            var crop_mage_holder_height = 510;
            if ($(window).width() < 1000) {
              crop_mage_holder_height = 215;
            }
            var crop_sizes = maximizeSize(
              k_width,
              k_hight,
              image_original_width,
              image_original_height
            );

            cropWidth = crop_sizes.width;
            cropHeight = crop_sizes.height;
            console.log(cropWidth);
            if (shop_domain == "esprit-panoramique.myshopify.com") {
              if (k_hight > 230 && k_width > 340) {
                cropWidth = image_original_width;
                cropHeight = image_original_height;
              }
            }
            if (crop_set_main_img == 0) {
              $("#divchartContainer").width(
                aspectRatio * crop_mage_holder_height
              );
              $("#divchartContainer").height(crop_mage_holder_height);
              //$('#divchartContainer').css(' aspect-ratio', '0 0');

              crop_set_main_img = 1;
            }

            set_crop_load(aspectRatio);
            $("#divchartContainer").hide();
            //move_image();
          } else {
            $("#divchartContainer").width(actual_width);
            $("#divchartContainer").height(actual_height);
            $("#divchartContainer").css("backgroundPosition", "0 0");
          }
          /* */
        } else {
          $("#divchartContainer").width(actual_width);
          $("#divchartContainer").height(actual_height);
          $("#divchartContainer").css("background-size", w + "px " + h + "px");
        }

        $("#temp").hide();
      };
    } // prepare image function end
    function exclded_product_or_not(data_resp) {
      cust_data = data_resp.customizer;
      exclude_product = "";
      exclude_product = cust_data.exclude_products;
      excludeProductArr = exclude_product.split(",");
      for (i = 0; i < excludeProductArr.length; ++i) {
        try {
          if (excludeProductArr[i] == meta.product.id) {
            exclude_product = "true";
            break;
          } else {
            exclude_product = "false";
            break;
          }
        } catch (err) {}
      }
    }
    function attach_presset_button_events() {
      $(".preset_button").on("click", function () {
        $(".preset_button").removeClass("preset_button_selected");
        $(this).addClass("preset_button_selected");
        if (calc_type == "m2" || calc_type == "cm") {
          $(".cm-width").val($(this).attr("data-width"));
          $(".cm-height").val($(this).attr("data-height"));
          $(".cm-width").trigger("change");
        }
        if (calc_type == "sft" || calc_type == "inch") {
          $(".inch-width").val($(this).attr("data-width"));
          $(".inch-height").val($(this).attr("data-height"));
          $(".inch-width").trigger("change");
        }
      });
    }
    function get__preset_sizes_html() {
      if (preset_enable == "") {
        return "";
      }
      st_preset_details;
      var preset_buttons_html = "";
      for (var ps = 0; ps < st_preset_details.length; ps++) {
        var ps_width = st_preset_details[ps]["width"];
        var ps_height = st_preset_details[ps]["height"];
        preset_buttons_html +=
          `<div class="presize_btn__inline-tile--space " role="presentation" aria-expanded="false">
  <button type="button" data-width="` +
          ps_width +
          `" data-height="` +
          ps_height +
          `" class="preset_button presize_btn__inline-tile border-radius--medium">` +
          ps_width +
          ` x ` +
          ps_height +
          `</button>
</div>`;
      }
      var pr_ms_type = calc_type;
      if (calc_type == "m2") {
        pr_ms_type = "cm";
      } else if (calc_type == "sft") {
        pr_ms_type = "inch";
      }

      var preset_sizes_html =
        `
 
<div class="presizes-card overflow " >
    <div class="">
      <div class="">
        <div class="presize__label">
          <div class="presize__label_label">` +
        width_title +
        ` (` +
        pr_ms_type +
        `) x ` +
        height_title +
        ` (` +
        pr_ms_type +
        `)<span class="presize__value"> </span></div>
        </div>
        <div class="presize_btn_div presize_btn_div--tile">
        ` +
        preset_buttons_html +
        `
        </div>
      </div>
    </div>
  </div>
  `;
      return preset_sizes_html;
    }
    function set_api_data(data_resp) {
      st_preset_details = data_resp.preset_details;
      calc_type = data_resp.customizer.calc_type;
      prices_from_shopify = data_resp.customizer.prices_from_shopify;
      image_crop_required = data_resp.customizer.image_crop_required;
      repeat_image = data_resp.customizer.repeat_image;
      image_bottom_text = data_resp.customizer.image_bottom_text;
      is_inline = data_resp.customizer.is_inline;
      price_unit = data_resp.customizer.price_unit;
      preset_enable = data_resp.customizer.preset_enable;
      is_customize_image = data_resp.customizer.is_customize_image;
      price_zeros_issue = data_resp.customizer.price_zeros_issue;
      currency_symbol = data_resp.customizer.currency_symbol;
      show_special_request = data_resp.customizer.show_special_request;
      variants_id_class = $.trim(data_resp.customizer.variants_id_class);

      if (shop_domain == "window-kanopy.myshopify.com") {
        cust_data.cm_height = 1;
      }
      default_in_cm_width = cust_data.cm_width;
      default_in_cm_height = cust_data.cm_height;
      default_in_inch_width = cust_data.inch_width;
      default_in_inch_height = cust_data.inch_height;

      /*if(variant_dtls.featured_image !=null)
            {
              product_image_last_src=variant_dtls.featured_image.src;
            }*/

      cust_data = data_resp.customizer;
      smart_price_html = "";
      custBtn_text = "CUSTOMISE & BUY";

      btn_back_ground_color = cust_data.pop_btn_bgcolor;
      btn_text_color = cust_data.pop_btn_color;

      is_aspect_ratio_option = cust_data.aspect_ratio_chekbox;
      aspect_ratio_text =
        cust_data.aspect_ratio_text == ""
          ? aspect_ratio_text
          : cust_data.aspect_ratio_text;
      aspect_ratio_chekbox_display = cust_data.aspect_ratio_chekbox_display;
      cart_Btn_text = "Add To Cart";
      cart_btn_back_ground_color = cust_data.cart_btn_bgcolor;
      cart_btn_text_color = cust_data.cart_btn_color;
      pop_up_btn_width = cust_data.pop_up_btn_width;
      minimum_purchase_price = parseFloat(cust_data.minimum_order);
      note_desc = cust_data.spl_notes;

      if (pop_up_btn_width == "") {
        pop_up_btn_width = "auto";
      }

      if (show_special_request == "1") {
        special_request_style =
          'style="display:block;margin-top:5px !important"';
      }

      if (customize_btn_store.includes(shop_domain)) {
        button_style =
          "style='font-weight:400 !important;background-color:" +
          btn_back_ground_color +
          " !important; color:" +
          btn_text_color +
          " !important;margin-top:10px !important;border: none;text-transform: uppercase;font-size: 14px;width:" +
          pop_up_btn_width +
          "'";
      }
      if (shop_domain == "tapetenglueck.myshopify.com") {
        if ($(window).width() > 950) {
          $("head").append(`
              <style>
              .customize_buy_btn
              {
                order:2 !important;margin-top:0px !important;
              }
             
            
              }
            </style>`);

          button_style =
            "style='background-color:" +
            btn_back_ground_color +
            " !important; color:" +
            btn_text_color +
            " !important;width:" +
            pop_up_btn_width +
            "'";
        } else {
          $("head").append(`
              <style>
              .customize_buy_btn
              {
                order:5 !important;margin-top:10px !important;
              }
             
            
              }
            </style>`);
          button_style =
            "style='background-color:" +
            btn_back_ground_color +
            " !important; color:" +
            btn_text_color +
            " !important;width:" +
            pop_up_btn_width +
            "'";
        }
      } else {
        button_style =
          "style='background-color:" +
          btn_back_ground_color +
          " !important; color:" +
          btn_text_color +
          " !important;margin-top:10px !important;width:" +
          pop_up_btn_width +
          "'";
      }

      cart_button_style =
        "style='background-color:" +
        cart_btn_back_ground_color +
        " !important; color:" +
        cart_btn_text_color +
        " !important;margin-top:1rem;'";

      if (cust_data.pop_btn_text) {
        custBtn_text = cust_data.pop_btn_text;
      }
      if (cust_data.cart_btn_text) {
        cart_Btn_text = cust_data.cart_btn_text;
      }
    }

    function attach_variants_chnage_event() {
      $("form").each(function () {
        if ($(this).attr("action") == "/cart/add") {
          $(this).on("change", function (e) {
            if ($(e.target).hasClass("conversion_txtboxes") == true) {
            } else {
              (async () => {
                variant_dtls = await currentVariant();
                set_varaint_details();
                if (iselemetVisible($(".inch_cal_area")[0])) {
                  $(".inch-width").trigger("change");
                } else {
                  $(".cm-width").trigger("change");
                }
              })();
            }
          });

          return false;
        }
      });
    }
    function prepare_final_html(data_resp) {
      $("#AddToCart-product-template").text("BUY SAMPLE");
      $('option:contains("Default_cpc_")').hide();
      var asp_rat_html = "";
      if (is_aspect_ratio_option == "on") {
        var as_ch_checked = "";
        var as_ch_checked_style = "";
        if (aspect_ratio_chekbox_display == "1") {
          as_ch_checked = "checked";
          as_ch_checked_style = "display:none;";
        }
        asp_rat_html = `<div style="margin-top:5px !important;${as_ch_checked_style}">
                     
                      <input type="checkbox" id="chkAspectration" style="width:20px;height:18px;vertical-align:middle" ${as_ch_checked}/> 
                      <span style="vertical-align:middle">${aspect_ratio_text}</span>
                      </div>`;
      }
      var is_hide = true;
      $("form").each(function () {
        if ($(this).attr("action") == "/cart/add") {
          if ($(this).is('product-rerender product-form form.shopify-product-form')) {
    console.log('Matched');
}
else{
  return;
}

          if (is_inline == "on") {
            
         
             let ff_html= get_inch_section_html(true) +
                    get_inch_cm_switch_html(true) +
                    asp_rat_html +
                    get_price_notes_html(true)
                    const finalForm = document.querySelector('product-rerender product-form form.shopify-product-form');
                console.log('finalForm',finalForm)
                    if (finalForm) {
                      
                    finalForm.insertAdjacentHTML('beforeend', ff_html);
                  }

              var button_add_to_bag_html =
                '<div class="grid_row btn-app hide" style="margin-bottom:10px !important;text-align: center;">' +
                ' <button type="button" id="ms_sp_addto_cart" name="ms_sp_addto_cart" ' +
                ' class="cart-checkout-btn checkout-btn btn btn-lg" ' +
                cart_button_style +
                "  >" +
                cart_Btn_text +
                "</button>" +
                "</div>";

              $($('.ms_smart_price_main_div')[0]).after(button_add_to_bag_html);
              // if (is_hide == true) {
              //   $($(addtocart_class_names)[0]).hide();
              // }
            }
          } 
      });

      var figure_html =
        '<figure id="fig_pro" style="height:' +
        k_hight +
        "px;width:" +
        k_width +
        'px" >' +
        '<img id="main-imag"  style="max-width:100%;max-height:100%" src="' +
        product_image_last_src +
        '" />' +
        "</figure>";

      var back_gr_style = "";
      if (repeat_image == "") {
        back_gr_style =
          "background-size:cover;background-repeat:no-repeat fixed;";
      } else {
        back_gr_style =
          "background-repeat:repeat-x;max-width:100%;max-height:400px;";
      }
      if (image_bottom_text == "") {
        image_bottom_text =
          "MAXIMISE WINDOW OR ROTATE DEVICE TO LANDSCAPE FOR BEST PREVIEW";
      }
      smart_price_html +=
        '<div id="product_customizer" class="MS_ajax_modal">' +
        '<div class="MS_ajax_wrap">' +
        '<span class="MS_ajax_close">×</span>' +
        '<div class="MS_ajax_head"> <div class="head-heading">' +
        cust_data.pop_title +
        "</div>" +
        '<div class="head-descrb">' +
        cust_data.pop_description +
        "</div>" +
        "</div>" +
        '<div class="MS_ajax_body">' +
        '<div class="ajax_body_content">' +
        '<div id="temp" style="display:none">' +
        figure_html +
        "</div>" +
        '<div class="grid_row"> ' +
        '<div id="divSquare" ><canvas style="display:none" id="file-preview" ></canvas></div>' +
        '<div class="grid_col msp_span_2_of_3 ajax_column product_image" style="text-align:center;">' +
        '<div  id="divCrop" >' +
        '<img id="cropbox"  src="' +
        product_image_last_src +
        '" />' +
        "</div>" +
        '<div  id="divchartContainer" style="' +
        back_gr_style +
        "display:inline-block;background-image: url(" +
        product_image_last_src +
        '); "></div>' +
        ' <img id="chartContainer" src=' +
        product_image_last_src +
        ' style="max-width:100%;display: inline-block; width: 604px; height: 604px; object-fit:fill !important;"/ ><legend id="leg_value"></legend> <br/>' +
        '<div id="screen_note" style="font-size:12px;color:#767676">' +
        image_bottom_text +
        "</div> </div>";

      smart_price_html +=
        get_inch_section_html(false) +
        get_inch_cm_switch_html() +
        asp_rat_html +
        get_price_notes_html();

      var button_add_to_bag_html =
        '<div class="grid_row" style="text-align: center;">' +
        ' <button type="button" id="ms_sp_addto_cart" name="ms_sp_addto_cart" ' +
        ' class="cart-checkout-btn checkout-btn btn btn-lg" ' +
        cart_button_style +
        "  >" +
        cart_Btn_text +
        '</button> <p class="instruction" style="font-size:15px;">' +
        note_desc +
        "</p>" +
        "</div>";
      smart_price_html += button_add_to_bag_html;

      smart_price_html +=
        "</div></div></div>" +
        '<div class="MS_ajax_footer"></div></div></div><canvas id="myCanvas" height=1024 width=360></canvas>';

      $("body").append(smart_price_html);
      let buy_button_not_required_stores = ["purple-floors.myshopify.com"];
      if (buy_button_not_required_stores.includes(shop_domain)) {
        $(".shopify-payment-button__button").hide();
      }
    }

    function validate_attributes() {
      var is_error_exist = false;
      var error_html = `<span class="bold_error_message">
                              <small>This option is required.</small>
                            </span>`;
      if (shop_domain == "decochicnew.myshopify.com") {
        for (var i = 0; i < cust_pro_attr.length; i++) {
          var prope_str = `[name="properties[${cust_pro_attr[i]}]"]`;
          if ($(prope_str).length > 0) {
            if ($(prope_str).val() == "") {
              is_error_exist = true;

              if (
                $(".hulkapps_option_value").find("bold_error_message").length ==
                0
              ) {
                $(".hulkapps_option_child").after(error_html);
                $(".bold_error_message").css("color", "red");
              }
            }
          }
        }
        return is_error_exist;
      }

      for (var i = 0; i < cust_pro_attr.length; i++) {
        var prope_str = `[name="properties[${cust_pro_attr[i]}]"]`;
        if ($(prope_str).length > 0) {
          if ($(prope_str).val() == "") {
            is_error_exist = true;
            $(".bold_option_title").each(function () {
              if ($(this).html() == cust_pro_attr[i] + "*") {
                if ($(this).parent().hasClass("bold_option_error") == false) {
                  $(this).parent().addClass("bold_option_error");
                  $(this).parent().append(error_html);
                }
              }
            });
          } else {
            $(".bold_option_title").each(function () {
              if ($(this).html() == cust_pro_attr[i] + "*") {
                if ($(this).parent().hasClass("bold_option_error") == true) {
                  $(this).parent().removeClass("bold_option_error");
                  $(this).parent().find(".bold_error_message").remove();
                }
              }
            });
          }
        }
      }

      return is_error_exist;
    }
    function attach_popup_button_click_event() {
      $("#btn_ms_sm_pc_customize").on("click", function () {
        if (validate_attributes() == true) {
          return;
        }
        $("#divchartContainer").css(
          "background-image",
          "url(" + product_image_last_src + ")"
        );
        $(".MS_ajax_modal #chartContainer").attr("src", product_image_last_src);
        if (iselemetVisible($(".inch_cal_area")[0])) {
          set_image_width_heights("inch");
        } else {
          set_image_width_heights("cm");
        }

        var modal_popup = document.getElementById("product_customizer");

        var span_close = document.getElementsByClassName("MS_ajax_close")[0];
        span_close.onclick = function () {
          modal_popup.style.display = "none";
        };
        modal_popup.style.display = "block";
      });
    }
    function set_image_width_heights(type) {
      if (is_customize_image == "on") {
        $(".MS_ajax_modal #chartContainer").width($(".cm-width").val());
        $(".MS_ajax_modal #chartContainer").height($(".cm-height").val());
        var width_in_cm = parseInt($(".cm-width").val());
        var height_in_cm = parseInt($(".cm-height").val());
        prepare_image_sizes(width_in_cm, height_in_cm, 0);
        if (height_in_cm < 230)
          $(".MS_ajax_modal #chartContainer").css("background-size", "cover");
      } else {
        $(".MS_ajax_modal #chartContainer").width(600);
        $(".MS_ajax_modal #chartContainer").height(600);
        $(".MS_ajax_modal #chartContainer").css("background-size", "cover");
        $("#chartContainer").hide();
      }
    }

    function iselemetVisible(element) {
      const $element = $(element);
      return (
        $element.css("display") !== "none" &&
        $element.css("visibility") !== "hidden" &&
        $element.css("opacity") !== 0
      );
    }

    function attach_add_to_bag_event() {
      $("#ms_sp_addto_cart").on("click", function (event) {
        add_new_product(this);
      });
    }
    function display_load_spinner(obj) {
      var bwidth = $(obj).width();
      var loader = "<div class='progload'></div>";
      $(obj).html(loader);
      $(obj).width(bwidth);
    }

    var final_width = 0;
    var final_height = 0;
    var final_msr_type = "";
    function get_cart_item() {
      var ele1 = $(".inch_cal_area")[0];

      if (iselemetVisible(ele1)) {
        final_width = $(".inch-width").val();
        final_height = $(".inch-height").val();
        final_msr_type = "inch";
        if (is_circle_product) {
          cart_item = diameter_title + " " + $(".inch-width").val() + " inch";
        } else {
          cart_item =
            prope_w_text +
            $(".inch-width").val() +
            " inch" +
            " * " +
            prope_h_text +
            $(".inch-height").val() +
            " inch";
        }
      } else {
        final_width = $(".cm-width").val();
        final_height = $(".cm-height").val();
        final_msr_type = "cm";
        if (is_circle_product) {
          cart_item = diameter_title + " " + $(".cm-width").val() + " cm";
        } else {
          cart_item =
            prope_w_text +
            $(".cm-width").val() +
            " cm" +
            " * " +
            prope_h_text +
            $(".cm-height").val() +
            " cm";
        }
      }
    }

    function get_crop_image_b64() {
      var x1 = crop_size_coordinates.x;
      var y1 = crop_size_coordinates.y;
      var c_width = crop_size_coordinates.w;
      var c_height = crop_size_coordinates.h;

      var img = new Image();
      img.onload = function () {
        var canvas = $("#file-preview")[0];
        var context = canvas.getContext("2d");
        canvas.setAttribute("width", crop_size_coordinates.w);
        canvas.setAttribute("height", crop_size_coordinates.h);
        context.clearRect(0, 0, c_width, c_height);

        canvas.height = c_height;
        canvas.width = c_width;
        context.drawImage(
          img,
          x1,
          y1,
          c_width,
          c_height,
          0,
          0,
          c_width,
          c_height
        );

        // drawDataURIOnCanvas(imgData, canvas) ;
      };
      img.crossOrigin = "anonymous";

      img.setAttribute("crossorigin", "anonymous"); // works for me
      img.src = product_image_last_src;
    }
    function drawDataURIOnCanvas(strDataURI, canvas) {
      "use strict";
      var img = new window.Image();
      img.addEventListener("load", function () {
        canvas.getContext("2d").drawImage(img, 0, 0);
      });
      img.setAttribute("src", strDataURI);
    }
    function add_new_product(obj) {
      if (validate_attributes() == true) {
        return;
      }
      if (last_bag_price <= 0) {
        if (is_circle_product) {
          alert("Please enter diameter");
        } else {
          alert("Please enter " + width_title + " and " + height_title);
        }
        return;
      }
      display_load_spinner(obj);
      get_cart_item();
      var imgData = "";
      if (repeat_image == "") {
        if (image_crop_required == "on") {
          var canvas = $("#file-preview")[0];
          imgData = canvas.toDataURL("image/jpg");
        }
      }
      var thestring = $(".product_pricing").text();
      var theprice = thestring.replace(/^\D+/g, "");
      var inventory_location = "";
      var final_product_price = last_bag_price;
      if (shop_domain == "eurowalls.myshopify.com") {
        inventory_location = window.Shopify.currency.active;
        final_product_price =
          parseFloat(last_bag_price) / parseFloat(window.Shopify.currency.rate);
        final_product_price = final_product_price.toFixed(2);
      }

      setTimeout(function () {
        var fd = new FormData();
        fd.append("product_image", product_image_last_src);
        fd.append("product_price", final_product_price);
        fd.append("product_title", product_title),
          fd.append("product_id", product_id);
        fd.append("product_image_id", product_image_id);
        fd.append("final_width", final_width);

        fd.append("final_height", final_height);
        fd.append("final_msr_type", final_msr_type);
        fd.append("inventory_location", inventory_location);

        var variant_dtls_json = JSON.stringify(variant_dtls);
        fd.append("variant_dtls", variant_dtls_json);

        fd.append("img_data", imgData);
        //   fd=fd.serialize();
        $.ajax({
          url: smart_api_path + "/add_product_data?shop_domain=" + shop_domain,

          method: "post",
          dataType: "JSON",
          contentType: false,
          cache: false,
          processData: false,
          /* data: add_product_data,*/
          data: fd,
          async: false,
          success: function (data_repository) {
            /* other stuff */

            var b_qty = 1;
            if ($('[name="quantity"]').length > 0) {
              b_qty = $($('[name="quantity"]')[0]).val();
            }
            var add_appi_cart_data = {
              items: [
                {
                  quantity: b_qty,
                  id: data_repository.product.variants[0].id,
                  price: data_repository.product.variants[0].price,
                  properties: {
                    [prope_roll_text]: product_roll,
                    [prope_price_text]: last_bag_price,
                    Comment: $(".order_comment").val(),
                  },
                },
              ],
            };
            if (shop_domain == "kkkk1231214.myshopify.com") {
              add_appi_cart_data.items[0].properties["Lado da cordinha"] = $(
                "input:radio[name='Ladodacordinha']:checked"
              ).val();
            }
            add_appi_cart_data = add_custom_proeprties(add_appi_cart_data);
            if (upload_image_to_cart_urls.includes(shop_domain)) {
              add_cart_upload_image(cart_item, add_appi_cart_data);
            } else {
              add_cart_dynamically(cart_item, add_appi_cart_data);
            }

            //func2();
          },
        });
      }, 10);
    }
    function add_cart_upload_image(cart_item, add_appi_cart_data) {
      const data = new FormData();
      Object.entries(add_appi_cart_data.items[0]).forEach(
        ([prop_key, prop_value]) => {
          if (prop_key === "properties") {
            Object.entries(add_appi_cart_data.items[0].properties).forEach(
              ([prop_key_p, prop_value_p]) => {
                data.append(`properties[${prop_key_p}]`, prop_value_p);
              }
            );
          } else {
            data.append(prop_key, prop_value);
          }
        }
      );
      const fileInof = document.getElementById("myuplaodimg");
      data.append("properties[file]", fileInof.files[0]);
      $.ajax({
        url: "/cart/add.js",
        data: data,
        method: "post",
        dataType: "json",
        processData: false,
        contentType: false,
        async: false,
        success: function (data_repository) {
          /* other stuff */
          update_cart_count();
        },
        error: function (request, status, error) {
          alert(request.responseText);
        },
      });
    }
    function add_custom_proeprties(add_appi_cart_data) {
      for (var i = 0; i < cust_pro_attr.length; i++) {
        var prope_str = `[name="properties[${cust_pro_attr[i]}]"]`;
        if ($(prope_str).length > 0) {
          add_appi_cart_data.items[0].properties[cust_pro_attr[i]] =
            $(prope_str).val();
        }
      }

      return add_appi_cart_data;
    }
    function attach_inch_cm_change_events() {
      $(".ainch").click(function (e) {
        e.preventDefault();
        convertion_func("inch", this);
      });

      //centimeter click
      $(".acm").click(function (e) {
        e.preventDefault();
        convertion_func("cm", this);
      });
    }

    function set_default_values_and_trigger() {
      if (calc_type == "m2" || calc_type == "cm") {
        $(".cm-width").val(default_in_cm_width);
        $(".cm-height").val(default_in_cm_height);
        $(".cm-width").trigger("change");
        convertion_func("cm");
      } else if (calc_type == "sft" || calc_type == "inch") {
        $(".inch-width").val(default_in_inch_width);
        $(".inch-height").val(default_in_inch_height);
        $(".inch-width").trigger("change");
        convertion_func("inch");
      }
    }
    function set_varaint_details() {
      var defined_price = 0;
      if (prices_from_shopify == "") {
        defined_price = custom_price;
      } else {
        if (price_zeros_issue == "on") {
          var isString = false;
          var findDecimal = -1;
          try {
            findDecimal = custom_price.indexOf(".");
            if (findDecimal == -1) {
              custom_price = two_decimal_format(parseFloat(custom_price / 100));
            }
          } catch (ex) {
            custom_price = two_decimal_format(parseFloat(custom_price / 100));
          }
        }
        defined_price = custom_price;
      }
      /*if(variant_dtls.featured_image !=null)
{
  product_image_last_src=variant_dtls.featured_image.src;
}*/
      if (price_unit == "m2") {
        shopify_m2_price = defined_price;
        shopify_sft_price = two_decimal_format(shopify_m2_price / 10.7636);
      } else if (price_unit == "sft") {
        shopify_sft_price = defined_price;
        shopify_m2_price = two_decimal_format(shopify_sft_price * 10.7636);
      } else if (price_unit == "cm") {
        shopify_m2_price = defined_price;
        shopify_sft_price = two_decimal_format(shopify_m2_price / 0.155);
      } else if (price_unit == "inch") {
        shopify_sft_price = defined_price;
        shopify_m2_price = two_decimal_format(shopify_sft_price * 0.155);
      }
    }
    function add_css() {
      if (shop_domain == "tapetenglueck.myshopify.com") {
        if ($(window).width() > 950) {
          $("head").append(`
      <style>
      @media (min-width: 1100px)
      {     
        .customize_buy_btn
        {
          order:2 !important;margin-top:0px !important;
        }
     
    
      }
    </style>`);
        } else if (shop_domain == "faberin-com.myshopify.com") {
          $("head").append(`
      <style>
      .ajax_body_content img{height:400px !important}
        .ajax_body_content input[type="number"]
      {
        height:30px !important
      }
      #ms_sp_addto_cart{
        width:100% !important;
        height:46px !important;
        background-color:#ffffff !important; 
      }
    </style>`);
        } else {
          $("head").append(`
      <style>
      @media (max-width: 1099px)
      {  
      .customize_buy_btn
      {
        order:5 !important;margin-top:20px !important;
      }
     
    
      }
      .ms_sp_spl_notes_text
      {
        font-weight:bold !important
      }
    </style>`);
        }
      }
    }
    function add_cart_dynamically(cart_item, add_appi_cart_data) {
      $.ajax({
        url: "/cart/add.js",
        data: add_appi_cart_data,
        method: "post",
        dataType: "json",
        /* data: add_product_data,*/

        async: false,
        success: function (data_repository) {
          /* other stuff */

          update_cart_count();
        },
        error: function (request, status, error) {
          alert(request.responseText);
        },
      });
    }
    function update_cart_count() {
      window.location.href = base_url_shopify + "/cart";
    }

    async function _getCurrentProduct() {
      const product = document.querySelector(`script[id*='ProductJson']`);

      if (product) {
        return JSON.parse(product.innerHTML);
      }

      let url;

      url = `https://${window.location.host + window.location.pathname}.json`;

      return new Promise(async (resolve, reject) => {
        let response = await fetch(url);

        let { product } = await response.json();

        window.ezfy_product = product;

        resolve(product);
      });
    }
    function getUrlVars() {
      var vars = [],
        hash;
      var hashes = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=");
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    }
    async function _getCurrentVariant() {
      const product = await _getCurrentProduct();
      product_title = product.title;
      main_prod_details = product;
      product_id = product.id;

      if (circle_rectangle_stores.includes(shop_domain)) {
        if (product.tags != null) {
          var st_prd_tags = "";
          if (product.tags.length > 0) {
            try {
              st_prd_tags = product.tags.split(",");
            } catch (ex) {
              st_prd_tags = product.tags;
            }
          }

          for (var stg = 0; stg < st_prd_tags.length; stg++) {
            var shp_tag_vlaue = $.trim(st_prd_tags[stg]);
            if (shp_tag_vlaue == "ms-smt-circular-rectangular") {
              is_both_rect_circle = true;

              break;
            } else if (shp_tag_vlaue == "ms-smt-rectangular") {
              is_both_rect_circle = false;
              is_circle_product = false;
              break;
            } else if (shp_tag_vlaue == "ms-smt-circular") {
              is_both_rect_circle = false;
              is_circle_product = true;
              break;
            }
          }
        }
      }
      const variant = await _getVariantID(product);
      return variant;
    }

    async function _getVariantID(product) {
      var options = document.querySelector(`.product-form__variants`);

      var currentVariantID = getUrlVars()["variant"];
      if (options == null) {
        if (variants_id_class.length > 0) {
          options = document.querySelector(variants_id_class);
        }
      }
      if (getUrlVars()["variant"] === undefined) {
        if (options != null) {
          currentVariantID = options.selectedOptions[0].value;
        } else {
          var vts_drop_down = $("select").filter(function () {
            return (
              $(this).attr("name") == "id" && $(this).css("display") == "none"
            );
          });
          if (vts_drop_down.length > 0) {
            currentVariantID = $(vts_drop_down).val();
          } else {
            currentVariantID = "0";
          }
        }
      }
      currentVariantID = parseInt(currentVariantID.trim().toLowerCase());
      console.log(product);
      const variant = product.variants.filter(
        (e) => e.id === currentVariantID
      )[0];

      if (variant != undefined && variant.featured_image != null) {
        if (variant.featured_image.src == "") {
          product_image_last_src = product.featured_image;
        } else {
          product_image_last_src = variant.featured_image.src;
        }
      } else {
        if (variant === undefined) {
          product_image_last_src = product.featured_image;
          if (product.featured_image == null) {
            if (product.images.length > 0) {
              product_image_last_src = product.images[0].src;
            }
          }
        } else {
          var image_id = variant.image_id;
          if (variant != undefined && image_id != null) {
            if (product.images.length > 0) {
              const curr_image = product.images.filter(
                (e) => e.id === image_id
              )[0];
              product_image_last_src = curr_image.src;
            }
          } else {
            product_image_last_src = product.featured_image;
            if (product.featured_image == null) {
              if (product.images.length > 0) {
                product_image_last_src = product.images[0].src;
              }
            }
          }
        }
      }
      if (product_image_last_src === undefined) {
        product_image_last_src = "";
      }
      if (product_image_last_src.indexOf("https:") == -1) {
        product_image_last_src = "https:" + product_image_last_src;
      }
      if (prices_from_shopify == "on") {
        if (variant === undefined) {
          if (product.price === undefined) {
            custom_price = product.variants[0].price;
          } else {
            custom_price = product.price;
          }
        } else {
          custom_price = variant.price;
        }
      }
      if (variant == undefined) {
        if (shop_domain == "window-kanopy.myshopify.com") {
          return product.variants[0];
        }
      }
      return variant;
    }

    async function currentVariant() {
      var variant = await _getCurrentVariant();
      console.log(variant);
      return variant;
    }

    setEnvURL();

    confirm_order();
    set_money_format();
    add_cs_urls();

    get_smart_price_data();
  };

  /******************/
  var loadScript = function (url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };
  if (
    typeof jQuery === "undefined" ||
    (parseInt(jQuery.fn.jquery) === 1 &&
      parseFloat(jQuery.fn.jquery.replace(/^1\./, "")) < 7.1)
  ) {
    loadScript(
      "//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js",
      function () {
        jQuery191 = jQuery.noConflict(true);
        manage_product_customizer(jQuery191);
      }
    );
  } else {
    manage_product_customizer(jQuery);
  }
})();
